<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-12-13 14:19:57
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-12-21 14:24:40
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/plan/components/addpurchaseCategory.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- Add Purchase Category -->
<template>
  <e-dialog
    class="agreement-dialog"
    dialog-title="编辑常采类目"
    :dialog-type="''"
    :center-dialog-visible="addPurchaseCategoryVisible"
    :popup-width="'700px'"
    @resetPopupData="cancelHandle"
    @submitPopupData="addMaterialHandle"
  >
    <div v-loading="dialogloading">
      <div class="flex-c" style="margin-bottom: 20px">
        <el-transfer
          v-model="selectCategoryList"
          filterable
          :props="defaultProps"
          :data="categoriesListAlign"
          :titles="['全部分类', '已选分类']"
        ></el-transfer>
      </div>
    </div>
  </e-dialog>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
import productApi from '@/modules/projectA/api/product/index';

export default {
  components: {
    eDialog,
  },
  props: {
    addPurchaseCategoryVisible: {
      type: Boolean,
      default: false,
    },
    categoriesListAlign: {
      type: Array,
      default() {
        return [];
      },
    },
    selectCategoryList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedCategory: [],
      defaultProps: {
        key: 'categoryId',
        label: 'categoryName',
      },
      nodeArr: [],
      dialogloading: false,
    };
  },

  computed: {
    // selectedCategory() {
    //   // console.log(this.categoriesListAlign);
    //   return this.selectCategoryList;
    //   // return this.getTreeNode(this.categoriesListAlign);
    // },
  },

  created() {},
  mounted() {
    // this.getSelectedCategoryList();
    console.log(this.categoriesListAlign);
  },
  methods: {
    cancelHandle() {
      this.$emit('cancelAddPurchaseCategoryHandle', false);
    },
    addMaterialHandle() {
      console.log(this.selectCategoryList);
      if (this.selectCategoryList.length) {
        this.$emit('addPurchaseCategoryHandle', this.selectCategoryList);
      } else {
        this.$message.error('请选择分类');
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
